import { render, staticRenderFns } from "./RouteGroupList.vue?vue&type=template&id=2b313987&"
import script from "./RouteGroupList.vue?vue&type=script&lang=js&"
export * from "./RouteGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports